import { createI18n } from 'vue-i18n'

import events$ from '@/services/Events'
import useBasket from '@/hooks/useBasket'

import { SUPPORTED_LANGUAGES } from '@/config/constants'

import { EVENT_LANGUAGE } from '@/config/events'

const FALLBACK_LANGUAGE = 'de'

const browserLanguage = document.documentElement.getAttribute('lang')?.toLowerCase()
const selectedLanguage = SUPPORTED_LANGUAGES.map(s => s.value).includes(browserLanguage)
  ? browserLanguage
  : FALLBACK_LANGUAGE

const i18n = createI18n({
  globalInjection: true,
  legacy: false,
  locale: selectedLanguage,
  warnHtmlMessage: false,
})

// TODO: Check if this function should undergo changes
async function loadTranslation(language, key = false) {
  console.warn('prototype is dead, long live prototype')

  if (key === 'aide') {
    const messages = await import(/* webpackChunkName: "lang-[request]" */ `@/language/aide/aide.${language}.json`)
    const content = i18n.global.getLocaleMessage(language)
    content[key] = messages.default
    i18n.global.setLocaleMessage(language, content)
    return content
  }
}

function setPageTitleAndDescription(meta) {
  if (!meta) {
    throw new Error('Missing param meta')
  }

  // check, if DVP-"app" is present
  if (document.querySelector('div[app-name=Configurator]')) {
    document.querySelector('title').innerText = [process.env.VUE_APP_PAGE_TITLE_PREFIX, meta.title]
      .filter(x => !!x)
      .join(' ')
    document.querySelector('meta[name=description]').content = meta.description
  }
}

async function updateTranslations(locale = i18n.global.locale.value, key = false) {
  const language = locale.toLowerCase()
  const { updateLanguage } = useBasket()
  const messages = await import(
    /* webpackChunkName: "lang-[request]" */ `@/language/content/content.${language}.json`
  ).then(res => res.default)

  if (key === 'aide') {
    const aideMessages = await import(/* webpackChunkName: "lang-[request]" */ `@/language/aide/aide.${language}.json`)
    messages[key] = aideMessages.default
  }

  // set locale and locale message
  i18n.global.setLocaleMessage(language, messages)
  i18n.global.locale.value = language

  updateHtmlPageData(language, i18n.global.tm)
  await updateLanguage(language)

  events$.emit(EVENT_LANGUAGE.LOADED, { language })
}

function updateHtmlPageData(locale, tm) {
  // update html language attribute
  document.documentElement.setAttribute('lang', locale)
  const meta = tm('meta')
  // check, if DVP-"app" is present
  if (document.querySelector('div[app-name=Configurator]')) {
    document.querySelector('title').innerText = [process.env.VUE_APP_PAGE_TITLE_PREFIX, meta.title]
      .filter(x => !!x)
      .join(' ')
    document.querySelector('meta[name=description]').content = meta.description
  }
}

export default function useTranslation() {
  return {
    browserLanguage,

    i18n,
    loadTranslation,
    setPageTitleAndDescription,
    updateTranslations,
  }
}
